<template>
    <div id="sql" class="mt">
        <a-row type="flex" justify="start" class="mt">
            <a-col>
                Name:
                <a-input placeholder="Basic usage" style="width: 240px" size="small" v-model="dsName"/>
            </a-col>
            <a-col class="ml4">
                Type:
                <a-select size="small" style="width: 240px" v-model="dsType">
                    <a-select-option value="SQL">SQL</a-select-option>
                    <a-select-option value="Procedure">Procedure</a-select-option>
                </a-select>
            </a-col>
        </a-row>
        <a-textarea placeholder="Basic usage" class="mt4" v-model="sqlVal" :rows="20" style="width: 70%;margin-bottom: 10px;"/>
        <a-row >
            <a-button type="primary" size="small" style="margin-left: 4px" @click="clearSql">{{$t('publicLang.Clear')}}</a-button>
            <a-button type="primary" size="small" style="margin-left: 4px" @click="BeautifyVal">{{$t('reportSetting.Beautify')}}</a-button>
            <a-button type="primary" size="small" style="margin-left: 4px">{{$t('reportSetting.Verify')}}</a-button>
            <a-button type="primary" size="small" style="margin-left: 4px" @click="saveSql(false)">{{$t('publicLang.Save')}}</a-button>
            <a-button type="primary" size="small" style="margin-left: 4px" @click="saveSql(true)">{{$t('reportSetting.Generate')}}</a-button>
            <a-tooltip placement="topLeft">
                <template slot="title">
                    <span>Download</span>
                </template>
                <a-button @click='downloadSql' type="primary" shape="circle" icon="download" size="small" class="ml4"/>
            </a-tooltip>
        </a-row>
    </div>
</template>
<script>
    import sqlFormatter from "sql-formatter";
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import axios from 'axios'
    import cookie from "../../../../api/cookie";
    export default{
        props:{
            dataSourceRow: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            headerUid:{
                type: String,
                default: function() {
                    return '';
                }
            }
        },
        data(){
            return{
                sqlVal: '',
                initValue: {},
                dsName: null,
                dsType: null

            }
        },
        watch:{
            dataSourceRow(v){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
//            初始化数据
            init(){
                ajax.get(api.REPORTGENERICSQL,{ uid: this.dataSourceRow.uid}).then(res=>{
                    this.initValue = res.data
                    this.sqlVal = this.initValue.SQL
                    this.dsName = this.initValue.dsName
                    this.dsType = this.initValue.dsType
                })
            },
            saveSql(type){
                let params ={
                    dsName: this.dsName,
                    dsType: this.dsType,
                    generate: type,
                    headerUid: this.headerUid,
                    uid: this.dataSourceRow.uid,
                    sql: this.sqlVal
                }
                ajax.post(api.REPORTGENERICSQL,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.$emit('emitSqlcomsVal',this.dsName)
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            BeautifyVal(){
                this.sqlVal = sqlFormatter.format(this.sqlVal)
            },
            clearSql(){
                this.sqlVal = null
            },
            downloadSql(){
                let ajaxurl = ajax.ajaxUrl();
                axios.post(ajaxurl + api.REPORTGENERICDOWNLOADXML, 
                {
                       sql:this.sqlVal,
                       dsType: this.dsType,
                 }
                    // responseType: "blob" //二进制流
                ).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    let blob = new Blob([res.data], {type: "application/octet-stream;charset=UTF-8"});
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download",'sql.xml');
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
            }
        }
    }
</script>